export const aciIcoInstagram = {
    iconName: 'ico-instagram',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                d: 'M17.6 5.6h1.6M7.2.8h9.6a6.4 6.4 0 016.4 6.4v9.6a6.4 6.4 0 01-6.4 6.4H7.2a6.4 6.4 0 01-6.4-6.4V7.2A6.4 6.4 0 017.2.8zm4.8 16a4.8 4.8 0 110-9.6 4.8 4.8 0 010 9.6z',
                stroke: 'currentColor',
                'stroke-width': '1.6',
                'stroke-linecap': 'round',
            },
        },
    },
};
